export default __webpack_public_path__ + "static/media/pattern_bottom.12d14f6b.png";